module.exports = __webpack_public_path__ + "static/media/ai-translations-soyun-2.75d7468b.md";